import {
  EcommerceRefundsAction,
  LOAD_ECOMMERCE_REFUNDS,
  LOAD_ECOMMERCE_REFUNDS_FAIL,
  LOAD_ECOMMERCE_REFUNDS_SUCCESS,
  LoadEcommerceRefunds,
  LoadEcommerceRefundsFail,
  LoadEcommerceRefundsSuccess,
} from "../actions";

export interface IEcommerceRefundsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceRefundsState {
  entities: { [websiteId: number]: IEcommerceRefundsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceRefundsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceRefundsState = initialState, action: EcommerceRefundsAction): IEcommerceRefundsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_REFUNDS:
      payload = (<LoadEcommerceRefunds>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_REFUNDS_SUCCESS:
      payload = (<LoadEcommerceRefundsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_REFUNDS_FAIL:
      payload = (<LoadEcommerceRefundsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
